import { render, staticRenderFns } from "./AlarmDetails.vue?vue&type=template&id=323ddb83&scoped=true"
import script from "./AlarmDetails.vue?vue&type=script&lang=ts"
export * from "./AlarmDetails.vue?vue&type=script&lang=ts"
import style0 from "./AlarmDetails.vue?vue&type=style&index=0&id=323ddb83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ddb83",
  null
  
)

export default component.exports